import handleXmlResponse from './xmlCommunicationHandler'
import xmlRequest from './xmlCommunicationRequest'

export default {
  handleXmlResponse,
  xmlRequest
}
